// แค่ความสะดวก ไม่ใช่ข้อมูลสำคัญ — localStorage อ่าน/เขียนไม่ได้ก็ไม่เป็นไร

const keyOf = vehicleId => `livestream-v2:camera:${vehicleId}`

export function recallCamera(vehicleId) {
  try {
    const raw = localStorage.getItem(keyOf(vehicleId))
    if (raw === null) return null
    const n = parseInt(raw, 10)
    return isNaN(n) ? null : n
  } catch (e) {
    return null
  }
}

export function rememberCamera(vehicleId, camera) {
  try {
    localStorage.setItem(keyOf(vehicleId), String(camera))
  } catch (e) {
    /* private mode / quota — ข้ามไป */
  }
}
